/**Dependencies */
import React, { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import { Accordion, Button, Col, Form, Row } from "react-bootstrap";
import { AsyncTypeahead } from "react-bootstrap-typeahead";

/**Components */
import { ModalTerminos } from "../components/ModalTerminos";

/**"*/
import "../styles/components/CheckOut.scss";

/**Services */
import { getHotelesRate } from "../services/searchService";
import { validateCupon } from "../services/markupService";
import { getActivePDP, getCodigoPaisesLada } from "../services/checkoutService";
import { OpenpayVpos, ConektaVpos, StripeVpos } from "../services/Booking";

/**Images */
import { FaChild, FaRegCalendarAlt } from "react-icons/fa";
import { IoMoonOutline } from "react-icons/io5";
import { IoMdBed } from "react-icons/io";
import { FaPerson } from "react-icons/fa6";
import { Link } from "react-router-dom";

// Helpers
import { Currency, fetchMarkup, FormatDate, FormatHours } from "../helpers";

// Hooks
import useForm from "../hooks/useForm";

export const Checkout = () => {
  const [dataCart] = useState(
    JSON.parse(sessionStorage.getItem("datosReserva")) || []
  );
  const [dataUser] = useState(
    JSON.parse(localStorage.getItem("dataUser")) || "{}"
  );
  const [totalReserva, setTotalReserva] = useState(0);
  const [totalHospedaje, setTotalHospedaje] = useState(0);
  const [totalActividades, setTotalActividades] = useState(0);
  const [totalTraslados, setTotalTraslados] = useState(0);
  const [comentarios, setComentarios] = useState("");
  const [dataUrl, setDataUrl] = useState("");
  const [messageButton, setMessageButton] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [markup, setMarkup] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [markupAct, setMarkupAct] = useState("");
  const [totalPax, setTotalPax] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [nights, setNights] = useState(0);
  const [validForm, setValidForm] = useState(false);
  const [expandedComments, setExpandedComments] = useState({ 0: false });
  // eslint-disable-next-line no-unused-vars
  const [checkRates, setCheckRates] = useState();
  const [showModal, setShowModal] = useState(false);
  const [cuponCode, setCuponCode] = useState("");
  const [validatedCupon, setValidatedCupon] = useState("");
  const [descount, setDescount] = useState(0);
  const [codeCountries, setCodeCountries] = useState([]);
  const [pdp, setPdp] = useState();
  const [urlPDP, setUrlPDP] = useState("");
  const reservaRef = useRef(null);
  const detallePagoRef = useRef(null);
  let requestPDP;
  let initialState = {
    name: "",
    lastName: "",
    phone: "",
    email: "",
    responsables: [],
    preguntas: [],
    datosTraslados: [],
    lada: "+52",
  };
  const validations = {
    name: {
      test: (value) => /^[a-zA-Z\s]*$/.test(value),
      message: "El nombre solo puede contener letras y espacios.",
    },
    lastName: {
      test: (value) => /^[a-zA-Z\s]*$/.test(value),
      message: "El apellido solo puede contener letras y espacios.",
    },
    phone: {
      test: (value) => /^\d*$/.test(value),
      message: "El teléfono solo puede contener números.",
    },
  };

  const { formData, handleChange, handleSubmit, setFormData } = useForm(
    initialState,
    validations
  );

  const formValid = () => {
    // Verificamos que los campos de texto simples estén completos
    const camposTextoLlenos = Object.entries(formData)
      .filter(([value]) => typeof value === "string")
      .every(([value]) => value.trim() !== "");

    // Verificamos que todos los responsables tengan name y lastName
    const responsablesValidos = Array.isArray(formData.responsables)
      ? formData.responsables.every(
          (res) =>
            typeof res.name === "string" &&
            res.name.trim() !== "" &&
            typeof res.lastName === "string" &&
            res.lastName.trim() !== ""
        )
      : true;

    const datosTrasladosValidos = Array.isArray(formData.datosTraslados)
      ? formData.datosTraslados.every(
          (res) =>
            typeof res.codigo === "string" &&
            res.codigo.trim() !== "" &&
            typeof res.compania === "string" &&
            res.compania.trim() !== ""
        )
      : true;

    // Verificamos que todas las preguntas estén respondidas
    const preguntasValidas = Array.isArray(formData.preguntas)
      ? formData.preguntas.every((actividad) =>
          actividad.every(
            (pregunta) =>
              typeof pregunta.respuesta === "string" &&
              pregunta.respuesta.trim() !== ""
          )
        )
      : true;

    return (
      camposTextoLlenos &&
      responsablesValidos &&
      preguntasValidas &&
      datosTrasladosValidos
    );
  };

  const handleValidation = () => {
    if (formValid()) {
      setValidForm(true);
      const request = construirRequestPDP();

      vposPago(request);
    } else {
      Swal.fire({
        title: "Existen campos vacios",
        text: "Por favor, completa todos los campos del formulario para poder realizar la reserva.",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "w-100 text-light btn-blue",
        },
      });
      setValidForm(false);
    }
  };

  useEffect(() => {
    // Asegurar que dataCart tenga la estructura correcta, incluso si viene malformada
    const { hospedaje = [], actividades = [], traslados = [] } = dataCart || {};

    // Caso 1: Solo tiene hospedaje
    if (
      hospedaje?.length > 0 &&
      actividades?.length === 0 &&
      traslados?.length === 0
    ) {
      setDataUrl(
        `/experiencias-resultado?t=destination&id=${
          hospedaje?.[0]?.codedestino
        }&in=${hospedaje?.[0]?.checkIn}&out=${hospedaje?.[0]?.checkOut}&pax=${
          hospedaje?.[0]?.paxes?.[0]?.num_adultos
        }|21,21|${
          hospedaje?.[0]?.paxes?.[0]?.num_menores
        }|${hospedaje?.[0]?.paxes?.[0]?.edad_menores.replace("|", ",")}`
      );
      setMessageButton("Descubre experiencias para tu viaje");

      // Caso 2: Solo tiene actividades
    } else if (
      actividades?.length > 0 &&
      hospedaje?.length === 0 &&
      traslados?.length === 0
    ) {
      setDataUrl(
        `/alojamientos?t=destino&id=${actividades?.[0]?.codedestino}&in=${
          actividades?.[0]?.checkin
        }&out=${actividades?.[0]?.checkout}&hab=1&pax1=${
          actividades?.[0]?.paxes?.[0]?.adults
        }|${
          actividades?.[0]?.paxes?.[0]?.minors
        }|${actividades?.[0]?.paxes?.[0]?.ages?.map((age) => age).join(",")}`
      );
      setMessageButton("Descubre hoteles para tu viaje");

      // Caso 3: Solo tiene traslados
    } else if (
      traslados?.length > 0 &&
      hospedaje?.length === 0 &&
      actividades?.length === 0
    ) {
      setDataUrl("/");
      setMessageButton("¿Quieres agregar un hotel o experiencia?");

      // Caso 4: Tiene hospedaje + actividades (traslados no importa)
    } else if (hospedaje?.length > 0 && actividades?.length > 0) {
      setDataUrl("/");
      setMessageButton("Seguir comprando");

      // Caso 5: Otras combinaciones (ej: hospedaje + traslados)
    } else if (
      hospedaje?.length > 0 ||
      actividades?.length > 0 ||
      traslados?.length > 0
    ) {
      setDataUrl("/");
      setMessageButton("Completa tu experiencia");

      // Caso por defecto (carrito vacío)
    } else {
      setDataUrl("/");
      setMessageButton("Empieza a planificar tu viaje");
    }
  }, [dataCart]);
  useEffect(() => {
    // Calcular cada total independientemente
    const hospedaje = Number(precioHospedajes());
    const actividades = Number(precioActivades());
    const traslados = Number(precioTraslados());

    // Sumar solo los que tienen valor mayor a 0
    const totalReserva = [hospedaje, actividades, traslados]
      .filter((price) => price > 0)
      .reduce((sum, price) => sum + price, 0);

    // Actualizar todos los estados en una sola operación
    setTotalReserva(totalReserva);
    setTotalHospedaje(hospedaje);
    setTotalActividades(actividades);
    setTotalTraslados(traslados);
  }, [dataCart, descount]);

  useEffect(() => {
    setTotalPax([totalAdults(), totalMinors(), totalRooms()]);
  }, [dataCart]);

  useEffect(() => {
    const fetchMarkupPanel = async () => {
      try {
        const markupData = await fetchMarkup("hoteleria");
        setMarkup(markupData.markup);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchMarkupPanel();
  }, []);
  useEffect(() => {
    const fetchMarkupPanelAct = async () => {
      try {
        const markupData = await fetchMarkup("experiencias");
        setMarkupAct(markupData.markup);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchMarkupPanelAct();
  }, []);

  useEffect(() => {
    if (dataCart) {
      const nights = dataCart?.hospedaje?.reduce(
        (total, item) => total + Number(item?.noches),
        0
      );
      setNights(nights);
    }
  }, [dataCart]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const checkRate = await fetchHotelRates();
        setCheckRates(checkRate);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCart]);

  useEffect(() => {
    const validateCupon = async () => {
      try {
        const cupon = await checkCupon();
        setDescount(cupon);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    validateCupon();
  }, [validatedCupon]);

  const checkCupon = async () => {
    const buildRequest = {
      coupon_code: validatedCupon,
      total_reserva: totalReserva,
    };
    try {
      if (buildRequest.coupon_code != "" && buildRequest.total_reserva > 0) {
        const response = await validateCupon(buildRequest);
        return response;
      } else {
        return;
      }
    } catch (error) {
      throw new Error("error connection", error);
    }
  };

  const fetchHotelRates = async () => {
    const rates = construirRequest();
    try {
      const response = await getHotelesRate(rates);
      return response;
    } catch (error) {
      console.error("Error fetching rates:", error);
      return [];
    }
  };

  const CodigosPaises = async () => {
    try {
      const response = await getCodigoPaisesLada();
      return response;
    } catch (error) {
      console.error("Error fetching rates:", error);
      return [];
    }
  };

  const construirRequest = () => {
    const rateKeys = dataCart?.hospedaje?.map((item) => ({
      rateKey: item?.rateKey,
    }));
    // Construir el objeto final
    const request = {
      habitaciones: rateKeys,
    };
    return request;
  };

  const precioHospedajes = () => {
    if (!dataCart || !dataCart?.hospedaje) return 0; // Evita errores si no hay datos

    return dataCart?.hospedaje
      ?.reduce((total, item) => total + item.totalPrices, 0)
      ?.toFixed(2);
  };

  const precioActivades = () => {
    if (!dataCart || !dataCart?.actividades) return 0; // Evita errores si no hay datos

    return dataCart?.actividades
      ?.reduce((total, item) => total + item?.totalAmount, 0)
      ?.toFixed(2);
  };

  const precioTraslados = () => {
    if (!dataCart || !dataCart?.traslados) return 0; // Evita errores si no hay datos

    return dataCart?.traslados
      ?.reduce((total, item) => total + item?.precio, 0)
      .toFixed(2);
  };

  const totalAdults = () => {
    if (!dataCart || !dataCart.hospedaje) return 0; // Evita errores si no hay datos
    const totalAdultos = dataCart?.hospedaje?.map(
      (hab, index) => hab?.paxes?.[index]?.num_adultos
    );
    return totalAdultos?.reduce((total, item) => total + Number(item), 0);
  };

  const totalMinors = () => {
    if (!dataCart || !dataCart.hospedaje) return 0; // Evita errores si no hay datos
    const totalmenores = dataCart?.hospedaje?.map(
      (hab, index) => hab?.paxes?.[index]?.num_menores
    );
    return totalmenores?.reduce((total, item) => total + Number(item), 0);
  };
  const totalRooms = () => {
    if (!dataCart || !dataCart.hospedaje) return 0; // Evita errores si no hay datos

    return dataCart?.hospedaje?.reduce(
      (total, item) => total + Number(item.rooms),
      0
    );
  };

  const onValidateClick = (code) => {
    setValidatedCupon(code);
  };
  useEffect(() => {
    const isMobile = window.innerWidth < 767;
    if (isMobile && descount?.valid && detallePagoRef.current) {
      detallePagoRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [descount]);
  const toggleShowMore = (index) => {
    setExpandedComments((prev) => ({
      ...prev,
      [index]: !prev[index], // Cambia solo el estado del comentario actual
    }));
  };
  // Función para abrir el modal
  const handleShowModal = (e) => {
    e.stopPropagation();
    setShowModal(true);
  };
  useEffect(() => {
    const pasarelaActiva = async () => {
      try {
        const pasarela = await getPdp();
        setPdp(pasarela);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    pasarelaActiva();
  }, [dataCart]);

  const vposPago = async (request) => {
    let response;
    try {
      if (pdp.nombre === "CONEKTA") {
        response = await ConektaVpos(request);
      } else if (pdp.nombre === "OPENPAY") {
        response = await OpenpayVpos(request);
      } else if (pdp.nombre === "STRIPE") {
        response = await StripeVpos(request);
      }
      setUrlPDP(response);
    } catch (error) {
      throw new Error("error connection", error);
    }
  };

  const countryCodesLada = async () => {
    try {
      const response = await CodigosPaises();
      return response;
    } catch (error) {
      throw new Error("Error fetching country codes:", error);
    }
  };

  const handleSearch = async () => {
    try {
      const response = await countryCodesLada();
      const data = await response;

      const countries = data.map((country) => ({
        code: String(country.completo || ""),
      }));
      // .filter((c) => c.code.trim() !== "");

      setCodeCountries(countries);
    } catch (error) {
      console.error("Error fetching countries:", error);
      setCodeCountries([]);
    }
  };
  const construirRequestPDP = () => {
    if (pdp.nombre === "CONEKTA") {
      let countBol = 0;
      let countPtc = 0;
      let countHdo = 0;
      requestPDP = {
        currency: "MXN",
        customer_info: {
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
        },
        line_items: [
          {
            name: formData.name,
            unit_price: parseFloat(
              descount?.descuento
                ? (totalReserva - descount?.descuento) * 100
                : totalReserva * 100
            ),
            quantity: 1,
          },
        ],
        metadata: {
          codigopais:
            dataCart?.hospedaje[0]?.codigoPais ||
            dataCart?.actividades[0]?.codigo_pais ||
            dataCart?.traslados[0]?.codigo_pais,
          nombreTitular: formData.name,
          apellidoTitular: formData.lastName,
          telefonoTitular: formData.phone,
          emailTitular: formData.email,
          idCliente: dataUser?.usuario && dataUser?.usuario?.id,
          ladaTitular: formData.lada,
          habCount: dataCart?.hospedaje?.length
            ? dataCart?.hospedaje?.length
            : 0,
          montoTotal: descount?.descuento
            ? totalReserva - descount?.descuento
            : totalReserva,
          // montoTotal: 1,
          montoNeto: dataCart?.hospedaje?.find((h) => h?.api === "hdo")
            ?.MealPlans?.MealPlan?.Total,
          montoCoupon: descount?.descuento
            ? totalReserva - descount?.descuento
            : totalReserva,
          ...formData.responsables?.reduce((acc, responsable, index) => {
            let contador =
              dataCart?.hospedaje?.[index].api === "bol"
                ? (countBol = countBol + 1)
                : (countHdo = countHdo + 1);
            // Usamos `index + 1` para asegurar que las propiedades sean únicas
            acc[
              `nombreResponsable${dataCart?.hospedaje?.[index].api}Hab${contador}`
            ] = responsable.name;
            acc[
              `apellidoResponsable${dataCart?.hospedaje?.[index].api}Hab${contador}`
            ] = responsable.lastName;
            return acc;
          }, {}),
          ...formData.preguntas?.reduce(
            (acc, preguntasPorActividad, actividadIndex) => {
              acc[`cantidadPreguntas${actividadIndex + 1}`] =
                preguntasPorActividad.length;
              preguntasPorActividad.forEach((pregunta, preguntaIndex) => {
                const act = actividadIndex + 1;
                const preg = preguntaIndex + 1;
                acc[`actividad${act}pregunta${preg}respuesta`] =
                  pregunta.respuesta;
                acc[`actividad${act}pregunta${preg}id`] = pregunta.id;
                acc[`actividad${act}pregunta${preg}texto`] = pregunta.texto;
              });
              return acc;
            },
            {}
          ),
          ...formData.datosTraslados?.reduce((acc, responsable, index) => {
            // Usamos `index + 1` para asegurar que las propiedades sean únicas
            acc[`codigoTraslado${index + 1}`] = responsable.codigo;
            acc[`companiaTraslado${index + 1}`] = responsable.compania;
            return acc;
          }, {}),
          cantidadExp: 1,
          comentario: comentarios,
          hotel: dataCart?.hospedaje[0]?.nombre
            ? dataCart?.hospedaje[0]?.nombre
            : "",
          experiencia: dataCart?.actividades[0]?.nameAct,
          ...(cuponCode ? { cupon: cuponCode } : ""),
        },
        checkout: {
          name: "Reserva Marzah Travel.",
          allowed_payment_methods: ["cash", "card", "bank_transfer"],
          type: "HostedPayment",
          // success_url: "http://localhost:3000/reserva/confirmada",
          // failure_url: "http://localhost:3000/reserva/confirmada",
          success_url: "https://marzahtravel.com/reserva/confirmada",
          failure_url: "https://marzahtravel.com/reserva/confirmada",
          redirection_time: 4,
        },
      };
    } else if (pdp.nombre === "OPENPAY") {
      let countBol = 0;
      let countPtc = 0;
      let countHdo = 0;
      requestPDP = {
        cliente: {
          nombre: formData.name,
          apellido: formData.lastName,
          telefono: formData.phone,
          email: formData.email,
        },
        cargo: {
          monto: parseFloat(
            descount?.descuento
              ? totalReserva - descount?.descuento
              : totalReserva
          ),
          // monto: 1,
          concepto: "Reserva Marzah Travel.",
          moneda: "MXN",
          // url: `http://localhost:3000/reserva/confirmada`,
          url: `https://marzahtravel.com/reserva/confirmada`,
          payments: "12",
        },
        metadata: {
          codigopais:
            dataCart?.hospedaje[0]?.codigoPais ||
            dataCart?.actividades[0]?.codigo_pais ||
            dataCart?.traslados[0]?.codigo_pais,
          nombreTitular: formData.name,
          apellidoTitular: formData.lastName,
          telefonoTitular: formData.phone,
          emailTitular: formData.email,
          idCliente: dataUser?.usuario && dataUser?.usuario?.id,
          ladaTitular: formData.lada,
          habCount: dataCart?.hospedaje?.length
            ? dataCart?.hospedaje?.length
            : 0,
          montoTotal: descount?.descuento
            ? totalReserva - descount?.descuento
            : totalReserva,
          // montoTotal: 1,
          montoNeto: dataCart?.hospedaje?.find((h) => h?.api === "hdo")
            ?.MealPlans?.MealPlan?.Total,
          montoCoupon: descount?.descuento
            ? totalReserva - descount?.descuento
            : totalReserva,
          ...formData.responsables?.reduce((acc, responsable, index) => {
            let contador =
              dataCart?.hospedaje?.[index].api === "bol"
                ? (countBol = countBol + 1)
                : (countHdo = countHdo + 1);
            // Usamos `index + 1` para asegurar que las propiedades sean únicas
            acc[
              `nombreResponsable${dataCart?.hospedaje?.[index].api}Hab${contador}`
            ] = responsable.name;
            acc[
              `apellidoResponsable${dataCart?.hospedaje?.[index].api}Hab${contador}`
            ] = responsable.lastName;
            return acc;
          }, {}),
          ...formData.preguntas?.reduce(
            (acc, preguntasPorActividad, actividadIndex) => {
              acc[`cantidadPreguntas${actividadIndex + 1}`] =
                preguntasPorActividad.length;
              preguntasPorActividad.forEach((pregunta, preguntaIndex) => {
                const act = actividadIndex + 1;
                const preg = preguntaIndex + 1;
                acc[`actividad${act}pregunta${preg}respuesta`] =
                  pregunta.respuesta;
                acc[`actividad${act}pregunta${preg}id`] = pregunta.id;
                acc[`actividad${act}pregunta${preg}texto`] = pregunta.texto;
              });
              return acc;
            },
            {}
          ),
          ...formData.datosTraslados?.reduce((acc, responsable, index) => {
            // Usamos `index + 1` para asegurar que las propiedades sean únicas
            acc[`codigoTraslado${index + 1}`] = responsable.codigo;
            acc[`companiaTraslado${index + 1}`] = responsable.compania;
            return acc;
          }, {}),
          cantidadExp: 1,
          comentario: comentarios,
          hotel: dataCart?.hospedaje[0]?.nombre
            ? dataCart?.hospedaje[0]?.nombre
            : "",
          experiencia: dataCart?.actividades[0]?.nameAct,
          ...(cuponCode ? { cupon: cuponCode } : ""),
        },
      };
    }
    if (pdp.nombre === "STRIPE") {
      let countBol = 0;
      let countPtc = 0;
      let countHdo = 0;
      requestPDP = {
        codigoPais:
          dataCart?.hospedaje[0]?.codigoPais ||
          dataCart?.actividades[0]?.codigo_pais ||
          dataCart?.traslados[0]?.codigo_pais ||
          "",
        email: formData.email,
        cargo: {
          moneda: "MXN",
          monto: parseFloat(
            descount?.descuento
              ? (totalReserva - descount?.descuento) * 100
              : totalReserva * 100
          ),
          // monto: 1000,
          concepto: "Reserva Marzah Travel.",
        },
        metadata: {
          codigopais:
            dataCart?.hospedaje[0]?.codigoPais ||
            dataCart?.actividades[0]?.codigo_pais ||
            dataCart?.traslados[0]?.codigo_pais,
          nombreTitular: formData.name,
          apellidoTitular: formData.lastName,
          telefonoTitular: formData.phone,
          emailTitular: formData.email,
          idCliente: dataUser?.usuario && dataUser?.usuario?.id,
          ladaTitular: formData.lada,
          habCount: dataCart?.hospedaje?.length
            ? dataCart?.hospedaje?.length
            : 0,
          montoTotal: descount?.descuento
            ? totalReserva - descount?.descuento
            : totalReserva,
          // montoTotal: 1,
          montoNeto: dataCart?.hospedaje?.find((h) => h?.api === "hdo")
            ?.MealPlans?.MealPlan?.Total,
          montoCoupon: descount?.descuento
            ? totalReserva - descount?.descuento
            : totalReserva,
          ...formData.responsables?.reduce((acc, responsable, index) => {
            let contador =
              dataCart?.hospedaje?.[index].api === "bol"
                ? (countBol = countBol + 1)
                : (countHdo = countHdo + 1);
            // Usamos `index + 1` para asegurar que las propiedades sean únicas
            acc[
              `nombreResponsable${dataCart?.hospedaje?.[index].api}Hab${contador}`
            ] = responsable.name;
            acc[
              `apellidoResponsable${dataCart?.hospedaje?.[index].api}Hab${contador}`
            ] = responsable.lastName;
            return acc;
          }, {}),
          ...formData.preguntas?.reduce(
            (acc, preguntasPorActividad, actividadIndex) => {
              acc[`cantidadPreguntas${actividadIndex + 1}`] =
                preguntasPorActividad.length;
              preguntasPorActividad.forEach((pregunta, preguntaIndex) => {
                const act = actividadIndex + 1;
                const preg = preguntaIndex + 1;
                acc[`actividad${act}pregunta${preg}respuesta`] =
                  pregunta.respuesta;
                acc[`actividad${act}pregunta${preg}id`] = pregunta.id;
                acc[`actividad${act}pregunta${preg}texto`] = pregunta.texto;
              });
              return acc;
            },
            {}
          ),
          ...formData.datosTraslados?.reduce((acc, responsable, index) => {
            // Usamos `index + 1` para asegurar que las propiedades sean únicas
            acc[`codigoTraslado${index + 1}`] = responsable.codigo;
            acc[`companiaTraslado${index + 1}`] = responsable.compania;
            return acc;
          }, {}),
          cantidadExp: 1,
          comentario: comentarios,
          hotel: dataCart?.hospedaje[0]?.nombre
            ? dataCart?.hospedaje[0]?.nombre
            : "",
          experiencia: dataCart?.actividades[0]?.nameAct,
          ...(cuponCode ? { cupon: cuponCode } : ""),
        },
        url_success: "https://marzahtravel.com/reserva/confirmada",
        // url_success: "http://localhost:3000/reserva/confirmada",
      };
    }
    return requestPDP;
  };

  const handlePayment = () => {
    const stopEvent = new Event("stopReservationTimerEvent");
    window.dispatchEvent(stopEvent);

    if (urlPDP) {
      if (pdp?.nombre === "CONEKTA") {
        window.location.replace(urlPDP?.data?.payment_link_url);
      } else if (pdp?.nombre === "OPENPAY") {
        window.location.replace(urlPDP?.url_openpay);
      } else if (pdp?.nombre === "STRIPE") {
        window.location.replace(urlPDP?.url_stripe);
      }
    }
  };

  const handleResponsableChange = (e, index, field) => {
    const value = e.target.value;

    setFormData((prevData) => {
      // Creamos una copia del array responsables (si no existe, creamos un array vacío)
      const updatedResponsables = [...(prevData.responsables || [])];

      // Si no existe el responsable en el índice, inicializamos un objeto vacío
      if (!updatedResponsables[index]) {
        updatedResponsables[index] = { name: "", lastName: "" };
      }

      // Actualizamos el campo específico dentro del responsable
      updatedResponsables[index][field] = value;

      // Retornamos el nuevo objeto formData con los responsables actualizados
      return {
        ...prevData,
        responsables: updatedResponsables,
      };
    });
  };

  const handleDatosTrasladosChange = (e, index, field) => {
    const value = e.target.value;

    setFormData((prevData) => {
      // Creamos una copia del array responsables (si no existe, creamos un array vacío)
      const updateDatosTraslados = [...(prevData.datosTraslados || [])];

      // Si no existe el responsable en el índice, inicializamos un objeto vacío
      if (!updateDatosTraslados[index]) {
        updateDatosTraslados[index] = { codigo: "", compania: "" };
      }

      // Actualizamos el campo específico dentro del responsable
      updateDatosTraslados[index][field] = value;

      // Retornamos el nuevo objeto formData con los responsables actualizados
      return {
        ...prevData,
        datosTraslados: updateDatosTraslados,
      };
    });
  };

  const handlePreguntaChange = (e, actividadIndex, preguntaIndex, field) => {
    const value = e.target.value;

    setFormData((prevData) => {
      const updatedPreguntas = [...(prevData.preguntas || [])];

      // Asegurarse de que existe la actividad y la pregunta
      if (!updatedPreguntas[actividadIndex]) {
        updatedPreguntas[actividadIndex] = [];
      }
      if (!updatedPreguntas[actividadIndex][preguntaIndex]) {
        updatedPreguntas[actividadIndex][preguntaIndex] = {
          id: "",
          texto: "",
          respuesta: "",
        };
      }

      updatedPreguntas[actividadIndex][preguntaIndex][field] = value;

      return {
        ...prevData,
        preguntas: updatedPreguntas,
      };
    });
  };

  const getPdp = async () => {
    try {
      const response = await getActivePDP();
      return response;
    } catch (error) {
      console.error("Error fetching rates:", error);
      return [];
    }
  };

  const handleSelectLada = (e) => {
    formData.lada = e?.[0]?.code;
  };

  const deleteUrlSession = () => {
    window.dispatchEvent(new Event("sessionStorageChange"));
    window.dispatchEvent(new CustomEvent("cartUpdated"));
    sessionStorage.removeItem("urlSession");
  };

  return (
    <div
      className="container position-relative checkout-form"
      style={{ marginTop: "25px" }}
    >
      <Row className="justify-content-center">
        <Col lg={12} className="pb-4">
          <Row className="justify-content-center">
            <div className={"InformationCheckoutContainer"}>
              <p className={"InformationCheckout p-3 fw-bolder"}>
                Para continuar con tu reservación es importante identificar los
                datos del titular y acompañantes.
              </p>
            </div>
          </Row>
        </Col>
        {/* <Col
          lg={10}
          className="pb-4 text-end d-flex justify-content-end align-items-start"
        >
          {dataCart?.hospedaje?.length == 0 && (
            <Link
              to={`/alojamientos?t=destino&id=${
                dataCart?.actividades?.[0]?.codedestino ||
                dataCart?.traslados?.[0]?.codedestino
              }&in=${
                dataCart?.actividades?.[0]?.checkin ||
                dataCart?.traslados?.[0]?.checkIn
              }&out=${
                dataCart?.actividades?.[0]?.checkout ||
                dataCart?.traslados?.[0]?.checkOut
              }&hab=1&pax1=${
                dataCart?.actividades?.[0]?.paxes?.[0]?.adults ||
                dataCart?.traslados?.[0]?.numAdultos
              }|${dataCart?.actividades?.[0]?.paxes?.[0]?.minors || 0}|${
                dataCart?.actividades?.[0]?.paxes?.[0]?.ages
                  ?.map((age) => age)
                  .join(",") || 0
              }`}
              onClick={deleteUrlSession}
            >
              <Button
                className={"btnPreventa w-auto border-0"}
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                Descubre hoteles para tu viaje
              </Button>
            </Link>
          )}
          {dataCart?.hospedaje?.length == 0 &&
            (dataCart?.actividades?.length == 0 ||
              dataCart?.traslados?.length == 0) && (
              <span className="mx-3" style={{ fontSize: "25px" }}>
                /
              </span>
            )}
          {dataCart?.actividades?.length == 0 && (
            <Link
              to={`/experiencias-resultado?t=destination&id=${
                dataCart?.hospedaje?.[0]?.codedestino ||
                dataCart?.traslados?.[0]?.codedestino
              }&in=${
                dataCart?.hospedaje?.[0]?.checkIn ||
                dataCart?.traslados?.[0]?.checkIn
              }&out=${
                dataCart?.hospedaje?.[0]?.checkOut ||
                dataCart?.traslados?.[0]?.checkOut
              }&pax=${
                dataCart?.hospedaje?.[0]?.paxes?.[0]?.num_adultos ||
                dataCart?.traslados?.[0]?.numAdultos
              }|21,21|${
                dataCart?.hospedaje?.[0]?.paxes?.[0]?.num_menores?.toString() ||
                0
              }|${
                dataCart?.hospedaje?.[0]?.paxes?.[0]?.edad_menores.replace(
                  "|",
                  ","
                ) || 0
              }`}
              onClick={deleteUrlSession}
            >
              <Button
                className={"btnPreventa w-auto border-0"}
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                Descubre experiencias para tu viaje
              </Button>
            </Link>
          )}
          {dataCart?.actividades?.length == 0 &&
          dataCart?.traslados?.length == 0 ? (
            <span className="mx-3" style={{ fontSize: "25px" }}>
              /
            </span>
          ) : (
            <></>
          )}
          {dataCart?.traslados?.length == 0 && (
            <Link to={"/traslados"} onClick={deleteUrlSession}>
              <Button
                className={"btnPreventa w-auto border-0"}
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                Descubre traslados para tu viaje
              </Button>
            </Link>
          )}
        </Col> */}
        <Col lg={6}>
          <Row>
            <Col
              lg={12}
              style={{
                padding: "20px",
                //border: "2px solid #005cff",
                borderRadius: "10px",
                backgroundColor: "#fff",
                marginBottom: "20px",
                boxShadow: "10px 10px 10px 10px rgba(0, 0, 0, 0.10)",
              }}
            >
              <h4 className="fw-bold">Titular de la reservación</h4>
              <p style={{ textAlign: "justify" }}>
                Será el responsable para cualquier aclaración de tu reservación.
              </p>
              <Form onSubmit={(e) => handleSubmit(e, formValid)}>
                <Row>
                  <Col lg={6}>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Nombre(s)</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Apellido(s)</Form.Label>
                      <Form.Control
                        type="text"
                        value={formData.lastName}
                        name="lastName"
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Correo electrónico</Form.Label>
                      <Form.Control
                        type="email"
                        value={formData.email}
                        name="email"
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Label>Teléfono</Form.Label>
                    <Form.Group
                      className="mb-3 d-flex"
                      controlId="formBasicEmail"
                    >
                      <AsyncTypeahead
                        id={"countryLada"}
                        labelKey="code" // <- debe coincidir con tus objetos
                        filterBy={["code"]}
                        minLength={2}
                        className={"lada text-black"}
                        onSearch={handleSearch}
                        defaultInputValue={formData.lada}
                        onChange={(e) => handleSelectLada(e)}
                        options={codeCountries}
                        placeholder="(+) Prefijo"
                        renderMenuItemChildren={(option) => (
                          <div>
                            <span>{option.code}</span>
                          </div>
                        )}
                      />
                      <Form.Control
                        type="text"
                        value={formData.phone}
                        name="phone"
                        onChange={handleChange}
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(/\D/g, ""))
                        }
                        required
                        className="w-100"
                        maxLength={10}
                      />
                    </Form.Group>
                  </Col>
                  {dataCart?.hospedaje?.length > 0 && (
                    <Col lg={12}>
                      <h4>Responsables de cada habitación</h4>
                      <p>Será responsable de cada habitación</p>
                    </Col>
                  )}
                  <Col lg={12}>
                    <Row>
                      {dataCart?.hospedaje && (
                        <>
                          {dataCart?.hospedaje?.map((item, index) => (
                            <React.Fragment key={index}>
                              <p className="fw-bold">
                                Responsable de la habitación {index + 1}
                              </p>
                              <Col lg={6}>
                                <Form.Group
                                  className="mb-3"
                                  controlId="formBasicEmail"
                                >
                                  <Form.Label>Nombre(s)</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name={`responsables[${index}].name`}
                                    value={formData.responsables?.[index]?.name}
                                    onChange={(e) =>
                                      handleResponsableChange(e, index, "name")
                                    }
                                    required
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg={6}>
                                <Form.Group
                                  className="mb-3"
                                  controlId="formBasicEmail"
                                >
                                  <Form.Label>Apellido(s)</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name={`responsables[${index}].lastName`}
                                    value={
                                      formData.responsables?.[index]?.lastName
                                    }
                                    onChange={(e) =>
                                      handleResponsableChange(
                                        e,
                                        index,
                                        "lastName"
                                      )
                                    }
                                    required
                                  />
                                </Form.Group>
                              </Col>
                            </React.Fragment>
                          ))}
                        </>
                      )}
                      {dataCart?.actividades && (
                        <>
                          {dataCart?.actividades?.map((item, index) => (
                            <>
                              {item.questionsAux.length > 0 && (
                                <>
                                  <h5>
                                    Preguntas de actividad{" "}
                                    <strong>{item.nombreActividad}</strong>
                                  </h5>
                                  {item.questionsAux?.map(
                                    (question, preguntaIndex) => (
                                      <Col lg={12} key={preguntaIndex}>
                                        <Form.Group className="mb-3">
                                          <Form.Label>
                                            {question.text}
                                          </Form.Label>
                                          <Form.Control
                                            type="text"
                                            required
                                            value={
                                              formData.preguntas?.[index]?.[
                                                preguntaIndex
                                              ]?.respuesta || ""
                                            }
                                            onChange={(e) => {
                                              handlePreguntaChange(
                                                e,
                                                index,
                                                preguntaIndex,
                                                "respuesta"
                                              );

                                              // Guardar también id y texto si no estaban
                                              const current =
                                                formData.preguntas?.[index]?.[
                                                  preguntaIndex
                                                ];
                                              if (
                                                !current?.id ||
                                                !current?.texto
                                              ) {
                                                setFormData((prevData) => {
                                                  const updated = [
                                                    ...(prevData.preguntas ||
                                                      []),
                                                  ];
                                                  if (!updated[index])
                                                    updated[index] = [];
                                                  if (
                                                    !updated[index][
                                                      preguntaIndex
                                                    ]
                                                  ) {
                                                    updated[index][
                                                      preguntaIndex
                                                    ] = {};
                                                  }
                                                  updated[index][
                                                    preguntaIndex
                                                  ].id = question.code;
                                                  updated[index][
                                                    preguntaIndex
                                                  ].texto = question.text;
                                                  return {
                                                    ...prevData,
                                                    preguntas: updated,
                                                  };
                                                });
                                              }
                                            }}
                                          />
                                        </Form.Group>
                                      </Col>
                                    )
                                  )}
                                </>
                              )}
                            </>
                          ))}
                        </>
                      )}
                      {dataCart?.traslados && (
                        <>
                          {dataCart?.traslados?.map((item, index) => (
                            <Col lg={12} key={index + 1}>
                              <p className="fw-bold">
                                Datos de traslado de{" "}
                                {item?.transferData.direction === "DEPARTURE"
                                  ? "SALIDA"
                                  : item?.transferData.direction === "ARRIVAL"
                                  ? "LLEGADA"
                                  : item?.transferData.direction}
                              </p>

                              <Col lg={12}>
                                <Row>
                                  <Col lg={12}>
                                    <h4>
                                      Servicio:{" "}
                                      {
                                        item?.transferData?.pickupInformation
                                          ?.from?.description
                                      }{" "}
                                      -{" "}
                                      {
                                        item?.transferData?.pickupInformation
                                          ?.to?.description
                                      }
                                    </h4>
                                  </Col>
                                  <Col lg={6}>
                                    <Form.Group
                                      className="mb-3"
                                      controlId="formBasicEmail"
                                    >
                                      <Form.Label>Numero de vuelo</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name={`datosTraslados[${index}].codigo`}
                                        value={
                                          formData.datosTraslados?.[index]
                                            ?.codigo
                                        }
                                        minLength={3}
                                        maxLength={7}
                                        onChange={(e) =>
                                          handleDatosTrasladosChange(
                                            e,
                                            index,
                                            "codigo"
                                          )
                                        }
                                        required
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col lg={6}>
                                    <Form.Group
                                      className="mb-3"
                                      controlId="formBasicEmail"
                                    >
                                      <Form.Label>Aerolínea</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name={`datosTraslados[${index}].compania`}
                                        value={
                                          formData.datosTraslados?.[index]
                                            ?.compania
                                        }
                                        onChange={(e) =>
                                          handleDatosTrasladosChange(
                                            e,
                                            index,
                                            "compania"
                                          )
                                        }
                                        required
                                      />
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </Col>
                            </Col>
                          ))}
                        </>
                      )}
                    </Row>
                  </Col>
                  <Col lg={12}>
                    <h4>Comentarios adicionales</h4>
                    <p>
                      Si deseas dejar algún mensaje y/o comentario a este
                      servicio.
                    </p>
                    <Form.Control
                      value={comentarios}
                      onChange={(e) => setComentarios(e.target.value)}
                      as="textarea"
                      rows={3}
                      required={false}
                    />
                  </Col>
                  <Col
                    lg={12}
                    style={{
                      padding: "15px",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      type="submit"
                      className={"btnCheckout w-50"}
                      onClick={() => {
                        handleValidation();
                        if (reservaRef.current) {
                          reservaRef.current.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                          });
                        }
                      }}
                    >
                      Siguiente
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Col>
            <Col lg={12}>
              <Row>
                {dataCart?.hospedaje?.length > 0 && (
                  <Col
                    lg={12}
                    style={{
                      padding: "20px",
                      //border: "2px solid #005cff",
                      borderRadius: "10px",
                      backgroundColor: "#fff",
                      marginBottom: "20px",
                      boxShadow: "10px 10px 10px 10px rgba(0, 0, 0, 0.10)",
                    }}
                    className="detalle-hospedaje-movil"
                  >
                    <h4 className="fw-bolder">
                      {dataCart?.hospedaje[0]?.nombreHotel}
                    </h4>
                    <div>
                      <p className="fw-bolder">
                        <FaRegCalendarAlt />{" "}
                        <span className="text-secondary fw-lighter">
                          Check in:
                        </span>{" "}
                        {FormatDate(dataCart?.hospedaje[0]?.checkIn)}
                      </p>
                      <p className="fw-bolder">
                        <FaRegCalendarAlt />{" "}
                        <span className="text-secondary fw-lighter">
                          Check out:
                        </span>{" "}
                        {FormatDate(dataCart?.hospedaje[0]?.checkOut)}
                      </p>
                      <p className="fw-bolder">
                        <IoMoonOutline />{" "}
                        <span className="text-secondary fw-lighter">
                          Noches:
                        </span>{" "}
                        {dataCart?.hospedaje[0]?.noches}
                      </p>
                      <p className="fw-bolder">
                        <IoMdBed />{" "}
                        <span className="text-secondary fw-lighter">
                          Habitaciones:
                        </span>{" "}
                        {dataCart?.hospedaje?.length}
                      </p>
                      <p className="fw-bolder">
                        <FaPerson />{" "}
                        <span className="text-secondary fw-lighter">
                          Adultos:
                        </span>{" "}
                        {totalPax[0]}
                      </p>
                      <p className="fw-bolder">
                        <FaChild />{" "}
                        <span className="text-secondary fw-lighter">
                          Menores:
                        </span>{" "}
                        {totalPax[1]}
                      </p>
                    </div>
                  </Col>
                )}
                <Accordion className="p-lg-0 p-2 mb-3 shadow" flush>
                  {dataCart?.hospedaje?.length > 0 && (
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        Detalles de tu Hospedaje{" "}
                      </Accordion.Header>
                      <Accordion.Body>
                        {dataCart?.hospedaje?.length > 0 && (
                          <Col
                            lg={12}
                            style={{
                              padding: "20px",
                              //border: "2px solid #005cff",
                              //borderRadius: "10px",
                              //backgroundColor: "#fff",
                              marginBottom: "20px",
                              //boxShadow: "10px 10px 10px 10px rgba(0, 0, 0, 0.10)",
                            }}
                          >
                            <Row>
                              <h4 className="fw-bold">
                                Resumen de la reservación
                              </h4>
                              <Col lg={12}>
                                <Row>
                                  {Object(
                                    dataCart?.hospedaje?.map((item, index) => {
                                      return (
                                        <React.Fragment key={index + 1}>
                                          <Col lg={6}>
                                            <h5>
                                              Detalles de la habitacion{" "}
                                              {index + 1}
                                            </h5>
                                            <p className="fw-bolder">
                                              {item.nombreHab}
                                            </p>
                                            <p className="fw-bolder">
                                              <span className="text-secondary fw-lighter">
                                                Plan de alimento:
                                              </span>{" "}
                                              {item.planAlimenticio ||
                                                item?.nombrePlan}
                                            </p>
                                            <p className="fw-bolder">
                                              <span className="text-secondary fw-lighter">
                                                Adultos:
                                              </span>{" "}
                                              {item.paxes[index].num_adultos}
                                            </p>
                                            <p className="fw-bolder">
                                              <span className="text-secondary fw-lighter">
                                                Menores:
                                              </span>{" "}
                                              {item.paxes[index].num_menores}{" "}
                                              <span className="text-secondary fw-lighter">
                                                | edades:
                                              </span>{" "}
                                              {item.paxes[index]?.edad_menores
                                                ? item.paxes[
                                                    index
                                                  ]?.edad_menores?.replace(
                                                    "|",
                                                    ", "
                                                  )
                                                : 0}
                                            </p>
                                          </Col>

                                          <Col lg={6}>
                                            <h5>Destino del alojamiento</h5>
                                            <p className="fw-bolder">
                                              {item.destino}
                                            </p>
                                            <p className="fw-bolder">
                                              <span className="text-secondary fw-lighter">
                                                Hotel:
                                              </span>{" "}
                                              {item.nombreHotel}
                                            </p>
                                            <p className="fw-bolder">
                                              <span className="text-secondary fw-lighter">
                                                CheckIn:
                                              </span>{" "}
                                              {FormatDate(item.checkIn)}
                                            </p>
                                            <p className="fw-bolder">
                                              <span className="text-secondary fw-lighter">
                                                CheckOut:
                                              </span>{" "}
                                              {FormatDate(item.checkOut)}
                                            </p>
                                          </Col>
                                          <Col lg={12}>
                                            <h6>Politicas de Cancelación</h6>
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html: item?.cancellationText,
                                              }}
                                            />
                                            <p
                                              style={{
                                                fontSize: "17px",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              Fecha y hora calculados en base a
                                              la hora local del destino.
                                            </p>
                                          </Col>
                                          {item?.rateComments && (
                                            <Col
                                              lg={12}
                                              style={{
                                                borderBottom:
                                                  "2px solid #0044aa",
                                                marginBottom: "20px",
                                              }}
                                            >
                                              <h5>
                                                Comentarios y observaciones de
                                                tu reservación
                                              </h5>
                                              <p>{item.rateComments}</p>
                                            </Col>
                                          )}
                                        </React.Fragment>
                                      );
                                    })
                                  )}
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                  )}
                  {dataCart?.actividades.length > 0 && (
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>
                        Detalle de tu Actividad{" "}
                      </Accordion.Header>
                      <Accordion.Body>
                        {dataCart?.actividades.length > 0 && (
                          <>
                            {dataCart?.actividades.map((item, index) => (
                              <Col
                                lg={12}
                                style={{
                                  padding: "20px",
                                  //border: "2px solid #005cff",
                                  //borderRadius: "10px",
                                  //backgroundColor: "#fff",
                                  marginBottom: "20px",
                                  //boxShadow: "10px 10px 10px 10px rgba(0, 0, 0, 0.10)",
                                }}
                              >
                                <h4 className="fw-bolder">
                                  {item.nombreActividad}
                                </h4>
                                <div>
                                  <p className="fw-bolder">
                                    <FaRegCalendarAlt />{" "}
                                    <span className="text-secondary fw-lighter">
                                      Fecha:
                                    </span>{" "}
                                    {FormatDate(item.selectedDate)}
                                  </p>
                                  <p className="fw-bolder">
                                    <FaPerson />{" "}
                                    <span className="text-secondary fw-lighter">
                                      Adultos:
                                    </span>{" "}
                                    {item.totalAdultos}
                                  </p>
                                  <p className="fw-bolder">
                                    <FaChild />{" "}
                                    <span className="text-secondary fw-lighter">
                                      Menores:
                                    </span>{" "}
                                    {item.totalMenores}
                                  </p>
                                  <p className="fw-bolder">
                                    <span className="text-secondary fw-lighter">
                                      Paquete:
                                    </span>{" "}
                                    {item.nombreModalidad}
                                  </p>
                                </div>
                                <div>
                                  <h5>Políticas de cancelación</h5>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item?.cancellationText,
                                    }}
                                  />
                                  {/* <p>
                                    A partir del{" "}
                                    <strong>{item.cancellationDateFrom}</strong>{" "}
                                    se cobrará{" "}
                                    <strong>
                                      {item.cancellationAmount}
                                      <span style={{ fontSize: "13px" }}>
                                        {" "}
                                        MXN
                                      </span>
                                    </strong>{" "}
                                    de penalidad por cancelación. Fecha y hora
                                    calculados en base a la hora local en
                                    destino.
                                  </p> */}
                                </div>
                                <div key={index}>
                                  <h5>Observaciones</h5>
                                  <div
                                    className={
                                      expandedComments[index]
                                        ? `showMore show`
                                        : `showMore`
                                    }
                                    dangerouslySetInnerHTML={{
                                      __html: item?.observaciones?.replaceAll(
                                        "//",
                                        "<br /><br />"
                                      ),
                                    }}
                                  />
                                  <Button
                                    onClick={() => toggleShowMore(index)}
                                    className={"btnCheckout w-auto"}
                                  >
                                    {expandedComments[index]
                                      ? "Ver menos"
                                      : "Ver más"}
                                  </Button>
                                </div>
                              </Col>
                            ))}
                          </>
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                  )}
                  {dataCart?.traslados?.length > 0 && (
                    <Accordion.Item eventKey="2">
                      <Accordion.Header>
                        Detalles de tu Traslado{" "}
                      </Accordion.Header>
                      <Accordion.Body>
                        {dataCart?.traslados?.length > 0 && (
                          <Col
                            lg={12}
                            style={{
                              padding: "20px",
                              //border: "2px solid #005cff",
                              // borderRadius: "10px",
                              //backgroundColor: "#fff",
                              marginBottom: "20px",
                              //boxShadow: "10px 10px 10px 10px rgba(0, 0, 0, 0.10)",
                            }}
                          >
                            <Row>
                              <Col lg={12}>
                                {dataCart?.traslados?.map((item, index) => (
                                  <Row key={index + 1}>
                                    <>
                                      <h5>
                                        Detalles del Traslado de{" "}
                                        {item?.transferData.direction ===
                                        "DEPARTURE"
                                          ? "SALIDA"
                                          : item?.transferData.direction ===
                                            "ARRIVAL"
                                          ? "LLEGADA"
                                          : item?.transferData.direction}
                                      </h5>
                                      <Col lg={4}>
                                        <p className="fw-bolder">
                                          {item?.transferData?.pickupInformation
                                            ?.from?.type === "ATLAS"
                                            ? "Hotel: "
                                            : item?.transferData
                                                ?.pickupInformation?.from
                                                ?.type === "IATA"
                                            ? "Aeropuerto: "
                                            : item?.transferData
                                                ?.pickupInformation?.from
                                                ?.type === "PORT"
                                            ? "Puerto: "
                                            : item?.transferData
                                                ?.pickupInformation?.from
                                                ?.type === "STATION"
                                            ? "Estación: "
                                            : ""}
                                          <br />
                                          <span className="text-secondary fw-lighter">
                                            {
                                              item?.transferData
                                                ?.pickupInformation?.from
                                                ?.description
                                            }
                                          </span>
                                        </p>
                                        <p className="fw-bolder">
                                          {item?.transferData?.pickupInformation
                                            ?.to?.type === "ATLAS"
                                            ? "Hotel: "
                                            : item?.transferData
                                                ?.pickupInformation?.to
                                                ?.type === "IATA"
                                            ? "Aeropuerto: "
                                            : item?.transferData
                                                ?.pickupInformation?.to
                                                ?.type === "PORT"
                                            ? "Puerto: "
                                            : item?.transferData
                                                ?.pickupInformation?.to
                                                ?.type === "STATION"
                                            ? "Estación: "
                                            : ""}
                                          <br />
                                          <span className="text-secondary fw-lighter">
                                            {
                                              item?.transferData
                                                ?.pickupInformation?.to
                                                ?.description
                                            }
                                          </span>
                                        </p>
                                      </Col>
                                      <Col lg={4}>
                                        <p className="fw-bolder">
                                          Direccion
                                          <br />
                                          <span className="text-secondary fw-lighter">
                                            {item?.transferData.direction ===
                                            "DEPARTURE"
                                              ? "SALIDA"
                                              : item?.transferData.direction ===
                                                "ARRIVAL"
                                              ? "LLEGADA"
                                              : item?.transferData.direction}
                                          </span>
                                        </p>
                                        <p className="fw-bolder">
                                          Tipo Servicio
                                          <br />
                                          <span className="text-secondary fw-lighter">
                                            {item?.transferData
                                              ?.transferType === "SHARED"
                                              ? "COMPARTIDO"
                                              : item?.transferData
                                                  ?.transferType === "PRIVATE"
                                              ? "PRIVADO"
                                              : item?.transferData
                                                  ?.transferType}
                                          </span>
                                        </p>
                                      </Col>
                                      <Col lg={4}>
                                        <p className="fw-bolder">
                                          Vehiculo
                                          <br />
                                          <span className="text-secondary fw-lighter">
                                            {item?.transferData?.vehicle?.name}
                                          </span>
                                        </p>
                                        <p className="fw-bolder">
                                          Categoria
                                          <br />
                                          <span className="text-secondary fw-lighter">
                                            {item?.transferData?.category?.name}
                                          </span>
                                        </p>
                                      </Col>
                                      <Col lg={12}>
                                        <p className="fw-bolder">
                                          Fecha - Hora
                                          <br />
                                          <span className="text-secondary fw-lighter">
                                            {item?.transferData
                                              ?.pickupInformation?.date
                                              ? FormatDate(
                                                  item?.transferData
                                                    ?.pickupInformation?.date
                                                )
                                              : ""}{" "}
                                            -{" "}
                                            {item?.transferData
                                              ?.pickupInformation?.time
                                              ? FormatHours(
                                                  item?.transferData
                                                    ?.pickupInformation?.time
                                                )
                                              : ""}
                                          </span>
                                        </p>
                                      </Col>
                                      <Col lg={12}>
                                        <h5>Detalles de la Reservación</h5>
                                        <Row>
                                          <Col lg={4}>
                                            <p className="fw-bolder">
                                              Precio
                                              <br />
                                              <span className="text-secondary fw-lighter">
                                                {Currency(
                                                  item?.transferData?.price
                                                    ?.totalAmount
                                                ) + " MXN"}
                                              </span>
                                            </p>
                                          </Col>
                                          <Col lg={4}>
                                            <p className="fw-bolder">
                                              Huespedes
                                              <br />
                                              <span className="text-secondary fw-lighter">
                                                Adultos:{" "}
                                                {item?.dataSearch?.adults},
                                                Menores:{" "}
                                                {item?.dataSearch?.children},{" "}
                                                Infantes:{" "}
                                                {item?.dataSearch?.infants}
                                              </span>
                                            </p>
                                          </Col>
                                          <Col lg={4}>
                                            <p className="fw-bolder">
                                              Servicio
                                              <br />
                                              <span className="text-secondary fw-lighter">
                                                {item?.transferData
                                                  ?.transferType === "SHARED"
                                                  ? "COMPARTIDO"
                                                  : item?.transferData
                                                      ?.transferType ===
                                                    "PRIVATE"
                                                  ? "PRIVADO"
                                                  : item?.transferData
                                                      ?.transferType}{" "}
                                                |{" "}
                                                {
                                                  item?.transferData?.vehicle
                                                    ?.name
                                                }{" "}
                                                -{" "}
                                                {
                                                  item?.transferData?.content
                                                    ?.category?.name
                                                }
                                              </span>
                                            </p>
                                          </Col>
                                        </Row>
                                        {item?.transferData?.pickupInformation
                                          ?.pickup?.checkPickup
                                          ?.mustCheckPickupTime === true && (
                                          <>
                                            <p
                                              className="fw-bolder bg-info text-white rounded-4"
                                              style={{
                                                padding: "10px",
                                                fontSize: "13px",
                                                width: "112px",
                                              }}
                                            >
                                              Check Pickup
                                            </p>
                                            <p>
                                              url:{" "}
                                              <Link
                                                rel="noopener noreferrer"
                                                to={
                                                  "https://" +
                                                  item?.transferData
                                                    ?.pickupInformation?.pickup
                                                    ?.checkPickup?.url
                                                }
                                                target="_blank"
                                              >
                                                {
                                                  item?.transferData
                                                    ?.pickupInformation?.pickup
                                                    ?.checkPickup?.url
                                                }{" "}
                                              </Link>
                                            </p>
                                            <p>
                                              Tiempo para consultar:{" "}
                                              {
                                                item?.transferData
                                                  ?.pickupInformation?.pickup
                                                  ?.checkPickup
                                                  ?.hoursBeforeConsulting
                                              }
                                              hrs
                                            </p>
                                          </>
                                        )}
                                      </Col>
                                      <Col lg={12}>
                                        <Row>
                                          <Col lg={6}>
                                            <h6>Información detallada</h6>
                                            <ul>
                                              <li>
                                                {
                                                  item?.transferData?.content
                                                    ?.transferDetailInfo[0]
                                                    ?.description
                                                }
                                              </li>
                                              <li>
                                                {
                                                  item?.transferData?.content
                                                    ?.transferDetailInfo[1]
                                                    ?.description
                                                }
                                              </li>
                                              <li>
                                                {
                                                  item?.transferData?.content
                                                    ?.transferDetailInfo[2]
                                                    ?.description
                                                }
                                              </li>
                                              <li>
                                                {
                                                  item?.transferData?.content
                                                    ?.transferDetailInfo[3]
                                                    ?.description
                                                }
                                              </li>
                                            </ul>
                                          </Col>
                                          <Col lg={6}>
                                            <h6>Politicas de Cancelación</h6>
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html: item?.cancellationText,
                                              }}
                                            />
                                            <p
                                              style={{
                                                fontSize: "17px",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              Fecha y hora calculados en base a
                                              la hora local del destino.
                                            </p>
                                          </Col>
                                        </Row>
                                      </Col>
                                      <Col lg={12}>
                                        <h5>Descripción Pickup</h5>
                                        <p
                                          className={
                                            expandedComments[index]
                                              ? `showMore show`
                                              : `showMore`
                                          }
                                        >
                                          {
                                            item?.transferData
                                              ?.pickupInformation?.pickup
                                              ?.description
                                          }
                                        </p>
                                        <Button
                                          onClick={() => toggleShowMore(index)}
                                          className={"btnCheckout w-auto"}
                                        >
                                          {expandedComments[index]
                                            ? "Ver menos"
                                            : "Ver más"}
                                        </Button>
                                      </Col>
                                    </>
                                  </Row>
                                ))}
                              </Col>
                            </Row>
                          </Col>
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                  )}
                </Accordion>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col lg={4} className="ps-lg-4">
          <Row style={{ position: "sticky", top: "3px" }}>
            <Col
              lg={12}
              className="d-none d-lg-block d-md-block"
              style={{
                padding: "20px",
                //border: "2px solid #005cff",
                borderRadius: "10px",
                backgroundColor: "#fff",
                marginBottom: "20px",
                boxShadow: "10px 10px 10px 10px rgba(0, 0, 0, 0.10)",
              }}
            >
              <h4 style={{ fontWeight: "bold" }}>¿Tienes un cupón?</h4>
              <Form className="d-flex mb-2">
                <Form.Group controlId="formBasicEmail">
                  <Form.Control
                    type="text"
                    onChange={(e) => setCuponCode(e.target.value)}
                  />
                </Form.Group>
                <div className="ps-3">
                  <Button
                    className={"btnCheckout w-auto"}
                    onClick={() => onValidateClick(cuponCode)}
                  >
                    Validar
                  </Button>
                </div>
              </Form>
              {descount != undefined && (
                <>
                  {!descount?.valid && (
                    <span className="text-danger">Cupon no valido</span>
                  )}
                </>
              )}
            </Col>
            <Col lg={12} className="d-block d-md-none mb-3">
              <Accordion className="p-lg-0 p-2 shadow border rounded" flush>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>¿Tienes un cupón?</Accordion.Header>
                  <Accordion.Body>
                    <Form className="d-flex mb-2">
                      <Form.Group
                        controlId="formBasicEmail"
                        className="flex-grow-1"
                      >
                        <Form.Control
                          type="text"
                          onChange={(e) => setCuponCode(e.target.value)}
                          placeholder="Ingresa tu cupón"
                        />
                      </Form.Group>
                      <div className="ps-3">
                        <Button
                          className="btnCheckout w-auto"
                          onClick={() => onValidateClick(cuponCode)}
                        >
                          Validar
                        </Button>
                      </div>
                    </Form>
                    {descount !== undefined && !descount?.valid && (
                      <span className="text-danger">Cupón no válido</span>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
            <Col
              ref={detallePagoRef}
              lg={12}
              style={{
                padding: "20px",
                //border: "2px solid #005cff",
                borderRadius: "10px",
                backgroundColor: "#fff",
                marginBottom: "20px",
                boxShadow: "10px 10px 10px 10px rgba(0, 0, 0, 0.10)",
              }}
            >
              <h4 style={{ fontWeight: "bold" }}>Detalle de pago</h4>
              <span>
                Hospedaje:{" "}
                <span className="fw-bolder">{Currency(totalHospedaje)}</span>{" "}
                <span className="fw-bolder" style={{ fontSize: "13px" }}>
                  MXN
                </span>
              </span>
              <br />
              <span>
                Actividad:{" "}
                <span className="fw-bolder">{Currency(totalActividades)}</span>{" "}
                <span className="fw-bolder" style={{ fontSize: "13px" }}>
                  MXN
                </span>
              </span>
              <br />
              <span>
                Traslado:{" "}
                <span className="fw-bolder">{Currency(totalTraslados)}</span>{" "}
                <span className="fw-bolder" style={{ fontSize: "13px" }}>
                  MXN
                </span>
              </span>
              <hr
                style={{
                  color: "#2a6583ea",
                  opacity: "1",
                  width: "100%",
                }}
              />
              <hr
                style={{
                  color: "#2a6583ea",
                  opacity: "1",
                  width: "100%",
                }}
              />
              <p>
                Total:{" "}
                <strong style={{ fontSize: "18px" }}>
                  {Currency(totalReserva)}{" "}
                  <span style={{ fontSize: "13px", fontWeight: "bold" }}>
                    MXN
                  </span>
                </strong>
                {descount?.valid && (
                  <>
                    <br />
                    Descuento:{" "}
                    <strong style={{ fontSize: "18px" }}>
                      {Currency(descount?.descuento)}{" "}
                      <span style={{ fontSize: "13px" }}>MXN</span>
                    </strong>
                    <br />
                    Total con descuento:{" "}
                    <strong style={{ fontSize: "18px" }}>
                      {Currency(totalReserva - descount?.descuento)}{" "}
                      <span style={{ fontSize: "13px" }}>MXN</span>
                    </strong>
                  </>
                )}
              </p>
            </Col>
            {validForm && (
              <Col
                lg={12}
                ref={reservaRef}
                style={{
                  padding: "20px",
                  //border: "2px solid #0044aa",
                  backgroundColor: "#696a6c",
                  marginBottom: "20px",
                  borderRadius: "10px",
                }}
              >
                <h4 className="text-white">Realizar la reserva</h4>
                <Form>
                  <Form.Group className="d-flex">
                    <Form.Check // prettier-ignore
                      type="checkbox"
                    />
                    <Form.Label className="ms-2 text-white">
                      He leído y acepto las{" "}
                      <Button
                        className="p-0 m-0 text-white"
                        variant="link"
                        onClick={handleShowModal}
                      >
                        políticas de Privacidad y Cancelación
                      </Button>
                    </Form.Label>
                    <ModalTerminos
                      openModal={showModal}
                      setOpenModal={setShowModal}
                    />
                  </Form.Group>
                  <div className="pt-3 d-flex justify-content-end">
                    <Button
                      className={"btnCheckoutPagar w-50"}
                      onClick={handlePayment}
                      disabled={urlPDP != "" ? false : true}
                    >
                      Pagar
                    </Button>
                  </div>
                </Form>
              </Col>
            )}
            {dataCart?.hospedaje?.length > 0 && (
              <Col
                lg={12}
                style={{
                  padding: "20px",
                  //border: "2px solid #005cff",
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  marginBottom: "20px",
                  boxShadow: "10px 10px 10px 10px rgba(0, 0, 0, 0.10)",
                }}
                className="detalle-hospedaje-desktop"
              >
                <h4 className="fw-bolder">
                  {dataCart?.hospedaje?.[0]?.nombreHotel}
                </h4>
                <div>
                  <p className="fw-bolder">
                    <FaRegCalendarAlt />{" "}
                    <span className="text-secondary fw-lighter">Check in:</span>{" "}
                    {FormatDate(dataCart?.hospedaje[0]?.checkIn)}
                  </p>
                  <p className="fw-bolder">
                    <FaRegCalendarAlt />{" "}
                    <span className="text-secondary fw-lighter">
                      Check out:
                    </span>{" "}
                    {FormatDate(dataCart?.hospedaje[0]?.checkOut)}
                  </p>
                  <p className="fw-bolder">
                    <IoMoonOutline />{" "}
                    <span className="text-secondary fw-lighter">Noches:</span>{" "}
                    {dataCart?.hospedaje[0]?.noches}
                  </p>
                  <p className="fw-bolder">
                    <IoMdBed />{" "}
                    <span className="text-secondary fw-lighter">
                      Habitaciones:
                    </span>{" "}
                    {dataCart?.hospedaje?.length}
                  </p>
                  <p className="fw-bolder">
                    <FaPerson />{" "}
                    <span className="text-secondary fw-lighter">Adultos:</span>{" "}
                    {totalPax[0]}
                  </p>
                  <p className="fw-bolder">
                    <FaChild />{" "}
                    <span className="text-secondary fw-lighter">Menores:</span>{" "}
                    {totalPax[1]}
                  </p>
                </div>
              </Col>
            )}
            {dataCart?.traslados?.length > 0 && (
              <Col
                lg={12}
                style={{
                  padding: "20px",
                  //border: "2px solid #005cff",
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  marginBottom: "20px",
                  boxShadow: "10px 10px 10px 10px rgba(0, 0, 0, 0.10)",
                }}
                className="detalle-hospedaje-desktop"
              >
                <h4 className="fw-bolder">Resumen de Traslado</h4>
                <div>
                  <p className="fw-bolder">
                    <span className="text-secondary fw-lighter">
                      {dataCart?.traslados[0]?.transferData?.pickupInformation
                        ?.from?.type === "ATLAS"
                        ? "Hotel: "
                        : dataCart?.traslados[0]?.transferData
                            ?.pickupInformation?.from?.type === "IATA"
                        ? "Aeropuerto: "
                        : dataCart?.traslados[0]?.transferData
                            ?.pickupInformation?.from?.type === "PORT"
                        ? "Puerto: "
                        : dataCart?.traslados[0]?.transferData
                            ?.pickupInformation?.from?.type === "STATION"
                        ? "Estación: "
                        : ""}
                    </span>{" "}
                    {
                      dataCart?.traslados[0]?.transferData?.pickupInformation
                        ?.from?.description
                    }
                  </p>
                  <p className="fw-bolder">
                    <span className="text-secondary fw-lighter">
                      {dataCart?.traslados[0]?.transferData?.pickupInformation
                        ?.to?.type === "ATLAS"
                        ? "Hotel: "
                        : dataCart?.traslados[0]?.transferData
                            ?.pickupInformation?.to?.type === "IATA"
                        ? "Aeropuerto: "
                        : dataCart?.traslados[0]?.transferData
                            ?.pickupInformation?.to?.type === "PORT"
                        ? "Puerto: "
                        : dataCart?.traslados[0]?.transferData
                            ?.pickupInformation?.to?.type === "STATION"
                        ? "Estación: "
                        : ""}
                    </span>{" "}
                    {
                      dataCart?.traslados[0]?.transferData?.pickupInformation
                        ?.to?.description
                    }
                  </p>
                  <p className="fw-bolder">
                    <span className="text-secondary fw-lighter">
                      Fecha de{" "}
                      {dataCart.traslados[0].tipoTraslado === "DEPARTURE"
                        ? "salida"
                        : "llegada"}
                      :
                    </span>{" "}
                    {dataCart?.traslados[0]?.transferData?.pickupInformation
                      ?.date
                      ? FormatDate(
                          dataCart?.traslados[0]?.transferData
                            ?.pickupInformation?.date
                        )
                      : ""}{" "}
                    -{" "}
                    {dataCart?.traslados[0]?.transferData?.pickupInformation
                      ?.time
                      ? FormatHours(
                          dataCart?.traslados[0]?.transferData
                            ?.pickupInformation?.time
                        )
                      : ""}
                  </p>
                  {dataCart?.traslados[1] && (
                    <p className="fw-bolder">
                      <span className="text-secondary fw-lighter">
                        Fecha de{" "}
                        {dataCart.traslados[1].tipoTraslado === "DEPARTURE"
                          ? "salida"
                          : "llegada"}
                        :
                      </span>{" "}
                      {dataCart?.traslados[1]?.transferData?.pickupInformation
                        ?.date
                        ? FormatDate(
                            dataCart?.traslados[1]?.transferData
                              ?.pickupInformation?.date
                          )
                        : ""}{" "}
                      -{" "}
                      {dataCart?.traslados[1]?.transferData?.pickupInformation
                        ?.time
                        ? FormatHours(
                            dataCart?.traslados[1]?.transferData
                              ?.pickupInformation?.time
                          )
                        : ""}
                    </p>
                  )}
                  <p className="fw-bolder">
                    <FaPerson />{" "}
                    <span className="text-secondary fw-lighter">Adultos:</span>{" "}
                    {dataCart?.traslados[0]?.dataSearch?.adults}
                  </p>
                  <p className="fw-bolder">
                    <FaChild />{" "}
                    <span className="text-secondary fw-lighter">Menores:</span>{" "}
                    {dataCart?.traslados[0]?.dataSearch?.children}
                  </p>
                  <p className="fw-bolder">
                    <FaChild />{" "}
                    <span className="text-secondary fw-lighter">Infantes:</span>{" "}
                    {dataCart?.traslados[0]?.dataSearch?.infants}
                  </p>
                </div>
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    </div>
  );
};
